import apis from "../../core/apis.js";

class BulkScriptsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.bulkScripts).get(options);
  }

  get(id) {
    return this.$resource(apis.bulkScripts + id).get();
  }

  post(item) {
    return this.$resource(apis.bulkScripts).save(item);
  }

  getTemplate(options) {
    return this.$resource(apis.bulkScripts + "template").get(options);
  }

  getFileUrl(id, options) {
    return this.$resource(apis.bulkScripts + id + "/file_url").get(options);
  }
}

export default BulkScriptsResource;



// WEBPACK FOOTER //
// ./src/resources/bulkScripts/bulkScripts.resource.js